import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  TextareaAutosize
} from "@material-ui/core";

import { DescriptionPopupStyle } from "./style";

function Popup(props) {
  const classes = DescriptionPopupStyle();
  const [scroll] = useState("body");
  const [desc, setDesc] = useState("");
  useEffect(() => {
    if(props.itemSelect.index > -1) {
      setDesc(props.itemSelect.item?.description || "");
    }
  }, [props.itemSelect])

  const saveDesc = () => {
    if(desc.length <= 70) {
      props.handleChange(
        {
          target:{
            name: "description",
            value: desc
          }
        }, props.itemSelect.index);
      props.handleClose();
    }
  }

  return (
    <>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
        scroll={scroll}
        onClose={props.handleClose}
      >
        <form noValidate autoComplete="off" className={classes.customForm}>
          <DialogTitle id="alert-dialog-title">
            Description
          </DialogTitle>
          <DialogContent>
            <div className="form-row">
              <div className="form-gourp full-width">
                <FormControl variant="outlined">
                  <TextareaAutosize
                    minRows={2}
                    maxRows={2}
                    id="description"
                    aria-label="description"
                    placeholder="Description"
                    onChange={(e) => setDesc(e.target.value)}
                    value={desc}
                    disabled={props.isGenerateInvoice}
                  />
                  <FormHelperText className="error-text">
                    {desc.length > 70 && "Description must not be more than 70"}
                  </FormHelperText>
                </FormControl>
              </div>
            </div>
          </DialogContent>
          <DialogActions className="bottom-button-block">
            <Button
              className="orange-btn primary-btn"
              color="inherit"
              disableElevation
              onClick={saveDesc}
              disabled={props.isGenerateInvoice}
            >
              SAVE
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default Popup;
